import { z } from "zod";

export const ZodVertex = z.object({ x: z.number(), y: z.number() });
export type Vertex = z.infer<typeof ZodVertex>;

export const ZodBox = z.object({
  vertices: z.array(ZodVertex),
});
export type Box = z.infer<typeof ZodBox>;

export const ZodPaperMetaData = z.object({
  height: z.number(),
  page: z.number(),
  width: z.number(),
});
export type PaperMetaData = z.infer<typeof ZodPaperMetaData>;
export const ZodPaperMetaDatum = z
  .object({
    pages: z.array(ZodPaperMetaData),
  })
  .catchall(z.any());
export type PaperMetadatum = z.infer<typeof ZodPaperMetaDatum>;

export const ZodElement = z.object({
  id: z.number(),
  bounding_box: z.array(ZodVertex),
  category: z.string(),
  sub_category: z.string().optional(),
  html: z.string(),
  text: z.string(),
  page: z.number(),
  base64_encoding: z.string().optional(),
});
export type LAElement = z.infer<typeof ZodElement>;
export type LAInferenceResult = LAElement[];

export const ZodCoordinates = z.object({ x: z.number(), y: z.number() });
export type Coordinates = z.infer<typeof ZodCoordinates>;

export const ZodContent = z.object({
  html: z.string(),
  markdown: z.string(),
  text: z.string(),
});
export type Content = z.infer<typeof ZodContent>;

export const ZodDPElement = z.object({
  id: z.number(),
  category: z.string(),
  sub_category: z.string().optional(),
  content: ZodContent,
  coordinates: z.array(ZodCoordinates).length(4).optional(),
  page: z.number().min(1),
  base64_encoding: z.string().optional(),
});
export type DPElement = z.infer<typeof ZodDPElement>;

export const ZodUsage = z.object({
  pages: z.number(),
});
export type Usage = z.infer<typeof ZodUsage>;

export const ZodImageLAOacJson = z.object({
  code: z.number().default(200),
  filename: z.string(),
  apiVersion: z.string(), // TODO : 제거
  modelVersion: z.string(),
  elements: z.array(ZodElement),
  metadata: ZodPaperMetaDatum,
  imageBase64: z.array(z.string()),
  mimeType: z.string(),
  html: z.string(),
  text: z.string(),
  api: z.string(),
  model: z.string(),
  content: ZodContent,
  elements_dp: z.array(ZodDPElement),
  usage: ZodUsage,
});

export type ImageLAOacJson = z.infer<typeof ZodImageLAOacJson>;
export type LAOacJsonResponse = z.infer<typeof ZodImageLAOacJson>;

export type FilteredLAJson = {
  api: string;
  model: string;
  elements: DPElement[];
  content: Content;
  usage: Usage;
};

export const getFilteredLAJson = (json: LAOacJsonResponse): FilteredLAJson => ({
  api: json.api,
  model: json.model,
  elements: json.elements_dp,
  content: json.content,
  usage: json.usage,
});
